// TooltipButton.jsx
import React from "react";

import "./TooltipButton.css"
const TooltipButton = ({
  icon,
  alt,
  tooltipText = "",   // متن تولتیپ اختیاری
  onClick,
  className = "",    // کلاس اضافی مثل "delete-btn"
}) => {
  return (
    <button className={`tooltip-btn ${className}`} onClick={onClick}>
      <img src={icon} alt={alt} className="icon-btn" />
      {tooltipText && <span className="tooltip">{tooltipText}</span>}
    </button>
  );
};

export default TooltipButton;
